import Api from './operations';
import { types } from './types';
export function updatePassword(old_secret, new_secret) {
  return function(dispatch) {
    return Api.updatePassword(old_secret, new_secret)
      .then(response => {
        console.log(response);
        switch (response.statusCode) {
          case 401:
          case 404:
          case 409:
          case 400:
            dispatch(updateFailed(response.message));
            break;
          case 201:
          case 200:
            dispatch(updateSuccess(response.message));
            break;
          default:
            dispatch(
              updateFailed('Could update password. Code:' + response.statusCode)
            );
        }
      })
      .catch(error => {
        console.log(error);
        dispatch(updateFailed('Unhandled error'));
        throw error;
      });
  };
}
export function updateSuccess(message) {
  return { type: types.UPDATE_SUCCESS, success: message };
}
export function updateFailed(error) {
  return { type: types.UPDATE_FAILED, error: error };
}
export function clearError() {
  return { type: types.CLEAR_ERROR };
}
export function clearSuccess() {
  return { type: types.CLEAR_SUCCESS };
}



// WEBPACK FOOTER //
// ./src/components/account/UpdatePassword/ducks/actions.js